module.exports = __webpack_public_path__ + "img/snapchat-ads.ecbcb161.jpg";